import { EMPTY_GENERAL_CSV_REPORT_ENTITY, GeneralCsvReportEntity } from "domain/entity/GeneralCsvReport/GeneralCsvReportEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface GeneralCsvReportDropdownOptions {
    reportTypeDropdownOptions: DropdownProps[],
    fileLocationDropdownOptions: DropdownProps[],
    opsLineDropdownOptions: DropdownProps[],
    customerTypeDropdownOptions: DropdownProps[],
}
export interface GeneralCsvReportViewChangeState extends BaseViewChangeSate {
}

export interface GeneralCsvReportModel {
    isLoading: boolean,
    reportIdList: string[],
    reportTypeList: string[],
    printQueueIdMap: { [key: string]: number },
    reportIdTypeMap: { [key: string]: string },
    dynamicOptions: GeneralCsvReportDropdownOptions,
    currentReport: GeneralCsvReportEntity,

}

export const EMPTY_GENERAL_CSV_REPORT_MODEL: GeneralCsvReportModel = {
    isLoading: false,
    dynamicOptions: {
        reportTypeDropdownOptions: [],
        fileLocationDropdownOptions: [],
        opsLineDropdownOptions: [],
        customerTypeDropdownOptions: []
    },
    printQueueIdMap: {},
    reportTypeList: [],
    currentReport: { ...EMPTY_GENERAL_CSV_REPORT_ENTITY },
    reportIdTypeMap: {},
    reportIdList: [],
}